module.exports = __webpack_public_path__ + "img/bg.bcb488e5.png";